export default __webpack_public_path__ + "static/media/Aura-Egg__83.b54bb658.png";